import { Stack, Text } from '@mantine/core';
import * as React from 'react';
import { ControlledInputs } from '../../../../../../react-commons/utils/read-only-inputs/controlledInputs';
import { ResourceType } from '../../../../resource/enumerations/ResourceType';
import { PersistableCreationResultSet } from '../../../../resource/resources/validation/persistableCreationResultSet';
import { MutationValidationResultComponent } from './MutationValidationResultComponent';
import { useMemo } from 'react';
import { MantineColumn, MantineTable } from '../../../../../../react-commons/components/table/MantineTable';

export const PersistableCreationResultSetComponent = ({
                                                          resultSet,
                                                          resourceType,
                                                      }: {
    resultSet: PersistableCreationResultSet;
    resourceType: ResourceType;
}) => {
    const columns = useMemo((): Array<
        MantineColumn<{ artifactType: string; notes: number; warnings: number; criticals: number; total: number }>
    > => {
        return [
            {
                type: 'string',
                accessorKey: 'artifactType',
                header: 'Artifact Type',
                Header: null,
                Cell: ({ row }) => (
                    <ControlledInputs.String nullable={false} readOnly={true} value={row.original.artifactType} />
                ),
            },
            {
                type: 'number',
                accessorKey: 'notes',
                header: 'Notes',
                Header: null,
                Cell: ({ row }) => (
                    <ControlledInputs.Number nullable={false} readOnly={true} value={row.original.notes} />
                ),
            },
            {
                type: 'number',
                accessorKey: 'warnings',
                header: 'Warnings',
                Header: null,
                Cell: ({ row }) => (
                    <ControlledInputs.Number nullable={false} readOnly={true} value={row.original.warnings} />
                ),
            },
            {
                type: 'number',
                accessorKey: 'criticals',
                header: 'Criticals',
                Header: null,
                Cell: ({ row }) => (
                    <ControlledInputs.Number nullable={false} readOnly={true} value={row.original.criticals} />
                ),
            },
            {
                type: 'number',
                accessorKey: 'total',
                header: 'Total',
                Header: null,
                Cell: ({ row }) => (
                    <ControlledInputs.Number nullable={false} readOnly={true} value={row.original.total} />
                ),
            },
        ];
    }, []);
    return (
        <Stack>
            {resultSet.successful && (
                <div style={{ display: 'inline-flex' }}>
                    <Text style={{ minWidth: 200 }}>Total Created Artifacts</Text>
                    <ControlledInputs.Number
                        nullable={false}
                        readOnly={true}
                        value={resultSet.numberOfArtifactsCreated}
                    />
                </div>
            )}
            {!resultSet.successful && resultSet.erroneousCreationResult && (
                <MutationValidationResultComponent
                    resourceType={resourceType}
                    resourceValidation={resultSet.erroneousCreationResult}
                />
            )}
            {resultSet.successful && resultSet.artifactsCreatedCountMap && (
                <MantineTable
                    columns={columns}
                    data={Object.keys(resultSet.artifactsCreatedCountMap).map((value) => ({
                        artifactType: value,
                        ...resultSet.artifactsCreatedCountMap[value],
                    }))}
                    label={<></>}
                    initialPageSize={10}
                    enableActions={false}
                />
            )}
        </Stack>
    );
};


